import React, {ReactNode, useContext, useEffect} from 'react';
import {useHistory, useLocation} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';

import {setInitialPath} from '../../redux/actions';
import {matchRoutes} from 'react-router-config';
import AppContext from './AppContext';
import {useAuthToken} from './AppHooks';
import Suspense from '../core/Suspense';
import {AppState} from '../../redux/store';
import AppContextPropsType from '../../types/AppContextPropsType';
import {MY_ACCOUNT_PATH} from 'modules/myAccount';
import {getAuthEmail, getAuthLoading} from '../../redux/selectors/Auth';

interface AuthRoutesProps {
  children: ReactNode;
}

const AuthRoutes: React.FC<AuthRoutesProps> = ({children}) => {
  const {pathname} = useLocation();
  const dispatch = useDispatch();
  const history = useHistory();
  const {routes} = useContext<AppContextPropsType>(AppContext);

  const [token, loading] = useAuthToken();

  const {initialPath} = useSelector<AppState, AppState['settings']>(
    ({settings}) => settings,
  );
  const haveEmail = !!useSelector(getAuthEmail);
  const authLoading = useSelector(getAuthLoading);
  const currentRoute = matchRoutes(routes, pathname)[0].route;

  useEffect(() => {
    function setInitPath() {
      if (
        initialPath === '/' &&
        [
          '/signin',
          '/signup',
          '/confirm-signup',
          '/reset-password',
          '/forget-password',
        ].indexOf(pathname) === -1
      ) {
        dispatch(setInitialPath(pathname));
      }
    }

    setInitPath();
  }, [dispatch, initialPath, loading, pathname, token]);

  useEffect(() => {
    if (!loading) {
      if (!token && currentRoute.auth && currentRoute.auth.length >= 1) {
        history.push('/signin');
      } else if (!token) {
        history.push('/signin');
      } else if (
        (pathname === '/signin' ||
          pathname === '/signup' ||
          pathname === '/confirm-signup') &&
        token
      ) {
        // @ts-ignore
        if (pathname === '/') {
          history.push('/dashboard');
        }
        // @ts-ignore
        else if (initialPath !== '/signin') {
          history.push(initialPath);
        } else {
          history.push('/dashboard');
        }
      } else if (token && !haveEmail && !authLoading) {
        history.push(MY_ACCOUNT_PATH);
      }
    }
  }, [
    token,
    loading,
    pathname,
    initialPath,
    haveEmail,
    currentRoute.auth,
    history,
    authLoading,
  ]);

  return <Suspense>{children}</Suspense>;
};

export default AuthRoutes;
